import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const CheckCircleIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue86c'}</MuiIcon>
    );
}